import 'whatwg-fetch'
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import { Vue2Storage } from 'vue2-storage';
import MaskedInput from 'vue-masked-input';
import moment from 'moment';
moment.locale('ru');

import './plugins/vuetify';

import App from './App.vue';
import router from './router';
import store from './store/index';

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from '@sentry/tracing';

Sentry.init({
  dsn: "https://ef88926e931448589deff0a746e6781f@o448380.ingest.sentry.io/5429685",
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
      attachProps: true,
      logErrors: true,
      attachStacktrace: true
    }),
    new Integrations.BrowserTracing()
  ],
  tracesSampleRate: 1
});

Vue.component('MaskedInput', MaskedInput);
Vue.prototype.moment = moment;

Vue.use(Vue2Storage, {
  prefix: 'app_',
  driver: 'local',
  ttl: 60 * 60 * 24 * 1000, // 24 часа
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
